var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "editable",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._t("prefix"), _c('span', {
    ref: "input",
    attrs: {
      "contenteditable": "plaintext-only"
    },
    on: {
      "input": function (e) {
        if (_vm.isValid(e.target.innerText)) {
          _vm.$emit('input', e.target.innerText);
          e.target.parentNode.classList.remove('error--text');
        } else {
          e.target.parentNode.classList.add('error--text');
        }
      },
      "focus": function (e) {
        _vm.active = true;
        _vm.select();
      },
      "blur": function (e) {
        e.target.innerText = _vm.value;
        e.target.parentNode.classList.remove('error--text');
        _vm.active = false;
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return function (e) {
          return e.target.blur();
        }.apply(null, arguments);
      }
    }
  }), _vm._t("suffix", null, {
    "active": _vm.active
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }